module.exports = __webpack_public_path__ + "Lato-Light.ff57e51d77dc76db583c.woff";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Light.woff
// module id = ../../../../../src/assets/fonts/Lato-Light.woff
// module chunks = styles